import React from 'react';
import { Box, Typography } from '@mui/material';

const HomeContent: React.FC = () => {
  return (
    <Box sx={{ 
      display: 'flex',
      minHeight: 'calc(100vh - 100px)',
      bgcolor: '#E5E5E5',
      position: 'relative',
      px: 0,
      gap: {
        xs: 2,
        md: 8
      },
      flexDirection: {
        xs: 'column',
        md: 'row'
      },
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      overflow: 'hidden',
      width: '100vw',
      maxWidth: '100vw',
    }}>
      {/* ส่วนซ้าย - รูปภาพ */}
      <Box sx={{ 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: { xs: '100%', md: '48vw' },
        px: 3,
        py: 2,
        overflow: 'hidden',
        mt: { xs: 0, md: 4 },
        mr: { xs: 0, md: 4 },
        position: 'relative',
      }}>
        {/* กรอบรูปพร้อมเงาฉายเฉียงขวาล่าง */}
        <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
          {/* เงาของกรอบรูป */}
          <Box
            sx={{
              position: 'absolute',
              top: '12px',
              left: '12px',
              width: '100%',
              height: '70vh',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              borderRadius: '8px',
              zIndex: 0,
              filter: 'blur(8px)',
            }}
          />
          
          <Box
            component="img"
            src="img/welcom_pic_L_sensor_1_durable1.jpg"
            alt="Sensor"
            sx={{
              width: '100%',
              maxWidth: 'none',
              height: '70vh',
              objectFit: 'cover',
              objectPosition: 'right',
              display: 'block',
              borderRadius: '8px',
              position: 'relative',
              zIndex: 1,
            }}
          />

        </Box>
      </Box>

      {/* ส่วนขวา - ข้อความ */}
      <Box sx={{
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 4 },
        width: '100%',
        height: {
          xs: 'auto',
          md: 'calc(100vh - 80px)'
        },
        boxSizing: 'border-box',
        maxWidth: '100%',
        marginRight: '90px',
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          p: 0,
          position: 'relative',
          boxSizing: 'border-box',
        }}>
          <Typography
            variant="h5"
            sx={{
              letterSpacing: 2,
              fontSize: 'clamp(1.2rem, 2vw, 1.5rem)',
              fontFamily: 'sans-serif',
              textAlign: 'left',
              width: '100%',
              mx: 'auto',
              mb: 0,
              wordBreak: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            "A PICTURE IS WORTH
          </Typography>
          <Typography
            variant="h5"
            sx={{
              letterSpacing: 2,
              fontSize: 'clamp(1.2rem, 2vw, 1.5rem)',
              fontFamily: 'sans-serif',
              textAlign: 'right',
              width: '100%',
              mx: 'auto',
              mb: 2,
              wordBreak: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            A THOUSAND WORDS."
          </Typography>
          <Box sx={{ 
            width: '100%',
            mx: 'auto',
            borderBottom: '1px solid #999',
            minHeight: '1px',
            py: 1,
            mb: { xs: 2, md: 4 },
            alignSelf: 'stretch',
          }} />
          <Typography
            variant="h5"
            sx={{
              letterSpacing: 3,
              fontSize: 'clamp(1.0rem, 2vw, 1.3rem)',
              textAlign: 'center',
              width: '100%',
              fontFamily: 'sans-serif',
              lineHeight: 1.3,
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              hyphens: 'auto',
              minHeight: 60,
            }}
          >
            ความแม่นยำ ในทุกสภาพแวดล้อม
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default HomeContent;